"use client"
import { useRouter } from "next/navigation"
import { toast } from "react-toastify"
import { useEffect } from "react"

const RedirectToLogin = () => {
    const router = useRouter()
    useEffect(() => {
        toast.warning("Please log in to access this page")
        router.replace("/auth/login")
    }, [router])

    return null
}

export default RedirectToLogin
